import { Routes } from '@angular/router';
import { Home } from './page/home/home';

export const routes: Routes = [
  {
    path: '',
    component: Home,
  },
  {
    path: 'status/:status',
    component: Home,
  },
  {
    path: 'checkout',
    loadComponent: () =>
      import('./page/checkout/checkout').then((m) => m.CheckoutComponent),
  },
  {
    path: 'renewal-table',
    loadComponent: () =>
      import('./component/renewal-table/renewal-table.component').then(
        (m) => m.RenewalTableComponent
      ),
  },
  {
    path: ':guid',
    loadComponent: () =>
      import('./page/renewal/renewal').then((m) => m.RenewalComponent),
  },
];
